"use client";

import { motion, useInView } from "framer-motion";
import Image from "next/image";
import { useRef } from "react";
import Button from "../Button";

export default function WhoWeAreSection() {
	const ref = useRef(null);
	const isInView = useInView(ref, { once: true, amount: 0.2 });

	return (
		<section ref={ref} className="py-16 md:py-24 bg-gray-50">
			<div className="container mx-auto px-4">
				<div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
					<motion.div
						initial={{ opacity: 0, x: -30 }}
						animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: -30 }}
						transition={{ duration: 0.8, ease: "easeOut" }}
						className="order-2 lg:order-1"
					>
						<div className="relative h-[400px] md:h-[500px] rounded-2xl overflow-hidden">
							<Image
								src="/assets/black/1.jpg"
								alt="Young football player in action"
								fill
								className="object-cover"
							/>
						</div>
					</motion.div>

					<motion.div
						initial={{ opacity: 0, x: 30 }}
						animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: 30 }}
						transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
						className="order-1 lg:order-2"
					>
						<p className="text-primary text-sm md:text-base font-bold uppercase tracking-wide mb-4">
							WHO WE ARE
						</p>

						<h2 className="text-3xl border-l-8 border-primary pl-2 md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
							FOUNDING OF THE
							<br />
							FOOTBALL ACADEMY
						</h2>

						<div className="space-y-4 text-gray-600 leading-relaxed">
							<p>
								At RFFA, we go beyond football training. we shape champions in
								character, mind, and talent. our academy uniquely combines
								world-class soccer coaching with quality education, ensuring
								that every player grows not only as an athlete but also as a
								well-rounded, intelligent individual prepared for life beyond
								the pitch.
							</p>

							<p>
								we believe that true excellence happens when academic brilliance
								meets sporting passion.
							</p>
						</div>

						<div className="mt-8">
							<Button href="/about" title="Check out what we do">
								Learn More
							</Button>
						</div>
					</motion.div>
				</div>
			</div>
		</section>
	);
}
